import React from "react"
import { toProduct } from "../../../../features/algolia/converters"
import { AlgoliaProductVariant } from "../../../../features/algolia/types/doc"
import { useLabels } from "../../../../features/contents/hooks"
import Typography from "../../../../ui/atoms/Typography"
import { CustomCol, CustomContainer, CustomRow } from "../../../../ui/spacings"
import { AlgoliaStaticSearchResult } from "../controller/state/types"
import StaticProductGridItem from "./StaticProductGridItem"
import StaticSearchFilterCategory from "./StaticSearchFilterCategory"
import StaticSearchPagination from "./StaticSearchPagination"

interface Props {
  staticSearch: AlgoliaStaticSearchResult
}

const AlgoliaStaticSearch = ({ staticSearch }: Props) => {
  const { getLabel } = useLabels()
  const products = staticSearch?.response?.results[0]?.hits?.map(
    (x: AlgoliaProductVariant) => toProduct(x)
  )
  const totResults = staticSearch.response?.results?.[0]?.nbHits
  return (
    <CustomContainer>
      <CustomRow>
        <CustomCol xs={12} lg={3}>
          {staticSearch.filters.categories.length > 0 && (
            <StaticSearchFilterCategory
              title="Categoria"
              filters={staticSearch.filters.categories}
            />
          )}
          {staticSearch.filters.brand.length > 0 && (
            <StaticSearchFilterCategory
              title="Brand"
              filters={staticSearch.filters.brand}
            />
          )}
        </CustomCol>
        <CustomCol xs={12} lg={9}>
          {totResults > 0 && (
            <div className="text-right">
              <Typography variant="body1">
                {totResults}{" "}
                {totResults === 1
                  ? getLabel("search", "article")
                  : getLabel("search", "articles")}
              </Typography>
            </div>
          )}
          <CustomRow>
            {products.map((x, index) => (
              <CustomCol
                xs={6}
                md={4}
                lg={3}
                xl={3}
                key={index}
                className="mb-16 sm:mb-10"
              >
                <StaticProductGridItem product={x} />
              </CustomCol>
            ))}
          </CustomRow>
          <div className="my-4">
            <StaticSearchPagination staticSearch={staticSearch} />
          </div>
        </CustomCol>
      </CustomRow>
    </CustomContainer>
  )
}

export default AlgoliaStaticSearch
